function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from '../http-client';
class PusherClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "authorize", async (request)=>this.post('/authorise/batch/channels', request)), _define_property(this, "heartbeat", (payload)=>this.post('/pusher/heartbeat', payload));
    }
}
export const PusherApi = new PusherClient();
